import { isFeatureEnabled } from 'owa-feature-flags';
import getPrimaryTimezoneLabelCloudSetting from '../selectors/getPrimaryTimezoneLabelCloudSetting';

const DEFAULT_PRIMARY_TIMEZONE_LABEL_FALLBACK = '';

/**
 * Gets the default value for the primary timezone label setting
 */
export default function getDefaultPrimaryTimezoneLabel(): string {
    if (!isFeatureEnabled('mon-multipleTimezones')) {
        return DEFAULT_PRIMARY_TIMEZONE_LABEL_FALLBACK;
    }

    const primaryTimezoneLabel = getPrimaryTimezoneLabelCloudSetting();

    return primaryTimezoneLabel != null
        ? primaryTimezoneLabel
        : DEFAULT_PRIMARY_TIMEZONE_LABEL_FALLBACK;
}
